import { TransactionTotalMonth } from "@/types/transaction.type";
import { ColumnDef } from "@tanstack/react-table";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";

export default function TableHeaderCash(): ColumnDef<TransactionTotalMonth>[] {
    const {t} = useTranslation();

    return [
        {
            header: t("dashboard.month"),
            accessorKey: "date",
            enableSorting: false,
            cell: ({row}) => moment(row.original.date, 'MM-YYYY').format('MMM YYYY')
        },
        {
            header: t("dashboard.revenue"),
            accessorKey: "income",
            enableSorting: false,
            meta: {
                className: "text-right",
            },
            cell: ({row}) => row.original.income.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})
        },
        {
            header: t("dashboard.expense"),
            accessorKey: "expense",
            enableSorting: false,
            meta: {
                className: "text-right",
            },
            cell: ({row}) => row.original.expense.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})
        },
        {
            header: t("dashboard.net_income"),
            accessorKey: "balance",
            enableSorting: false,
            meta: {
                className: "text-right",
            },
            cell: ({row}) => (row.original.income - row.original.expense).toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})
        },
        {
            header: t("dashboard.margin"),
            accessorKey: "margin",
            enableSorting: false,
            meta: {
                className: "text-right",
            },
            cell: ({row}) => {
                const income = row.original.income;
                const expense = row.original.expense;
                const margin = income - expense;
                return (margin / income * 100).toFixed(2) + "%";
            }
        }
    ]
}
